// extracted by mini-css-extract-plugin
export default {"oemCol":"VariantPublicationTable__oemCol-UP07H","clientTypeCol":"VariantPublicationTable__clientTypeCol-Nmz8j","releaseStageCol":"VariantPublicationTable__releaseStageCol-ahD98"};